define(
({
  "alert": "アラーム",
  "okay": "OK"
})
);
